import {Component, CSSProperties} from "react";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import FontIcon from "material-ui/FontIcon";
import {colors} from "material-ui/styles";
import copy from "copy-to-clipboard";

import {prepareStyles} from "src/utils/components";

const tokenPlaceholder = new Array(128).fill('*').join('');

interface TokenFieldProps {
  style?: CSSProperties;
  clientToken: string | null;
  onTokenGenerateButtonClick: () => {};
}

const styles = prepareStyles({
  tokenInputContainer: {
    flex: '1 1 0',
    marginRight: 24,
  },
  generateTokenButton: {
    flex: '0 0 auto',
  },
  copyTokenButton: {
    flex: '0 0 auto',
    backgroundColor: colors.green400,
  },
});

export default class TokenField extends Component<TokenFieldProps, {
  isTokenCopied?: boolean;
}> {
  node: TextField;
  state = {isTokenCopied: false};

  handleTokenClick = () => {
    const inputNode = this.node.getInputNode();
    inputNode.select();
  }

  onTokenCopyButtonClick = () => {
    if (copy(this.props.clientToken))
      this.setState({isTokenCopied: true});
  }

  setNode = (node: TextField) => {
    this.node = node;
  }

  render() {
    const clientToken = this.props.clientToken;
    const {isTokenCopied} = this.state;
    const doneIcon = <FontIcon className="material-icons">done</FontIcon>;

    return <div>
      <div style={this.props.style}>
        <div onClick={this.handleTokenClick}
             style={styles.tokenInputContainer}>
          <TextField fullWidth
                     floatingLabelText="Client token"
                     type={clientToken == null ? 'password' : 'text'}
                     disabled={clientToken == null}
                     readOnly={clientToken != null}
                     value={clientToken != null
                                        ? clientToken
                                        : tokenPlaceholder}
                     name="token"
                     ref={this.setNode}/>
        </div>
        {clientToken
          ? <RaisedButton primary
                          disabled={isTokenCopied}
                          style={styles.copyTokenButton}
                          onTouchTap={this.onTokenCopyButtonClick}
                          label={!isTokenCopied && "Copy"}
                          icon={isTokenCopied ? doneIcon : null}/>
          : <RaisedButton secondary
                          style={styles.generateTokenButton}
                          onTouchTap={this.props.onTokenGenerateButtonClick}
                          label="Generate"/>
        }
      </div>
      {clientToken == null
        ? 'Old token will be invalidated'
        : isTokenCopied
          ? null
          : 'Copy generated token. You will NOT be able to view it later'}
    </div>;
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/project/TokenField.tsx